import * as yup from 'yup';

export type ProductInputs = {
  product_id: object | null;
  storage_id: object | null;
  unit_id: object | null;
  quantity: number;
  available_stock: number;
  price: number;
  discount: number;
  discount_product: number;
  total: number;
  total_discount: number;
};

export const productSchema = yup.object().shape({
  unit_id: yup.mixed().required().label('unit'),
  storage_id: yup.mixed().required().label('storage'),
  price: yup.number().typeError('field must be a number.').label('price').required(),
  quantity: yup.number().typeError('field must be a number.').required(),
  available_stock: yup.number().typeError('field must be a number.'),
  discount: yup.number().typeError('field must be a number.'),
  total: yup.number().typeError('field must be a number.'),
  discount_product: yup.number().typeError('field must be a number.')
});

export const productUnitItemSchema = yup.object().shape({
  unit_id: yup.mixed().required().label('unit'),
});


export type InformationInputs = {
  customer_id: object | null;
  date: object;
  note: string;
  discount: number;
  sales_order_items: any[];
  payment: 0;
};

export const informationSchema = yup.object().shape({
  customer_id: yup.mixed().required().label('Customer'),
});
